import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FnChartDirective } from './amchart/fnchart.directive';
import { FnChartService } from './amchart/fnchart.service';

export * from './amchart/fnchart.directive';
export * from './amchart/fnchart.service';


/**
 * Provide FnChartDirective to set Default properies of ChartObject and Export FnChartDirective to create Chart of Different Type.
 * and making them available for import by NgModules that import this module.
 */
@NgModule({
  declarations: [FnChartDirective],
  imports: [
    CommonModule
  ],
  exports: [
    FnChartDirective
  ],
  providers: [FnChartService]
})
export class FnChartModule { }
